import React from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { SimP1StatusEnum } from '../../../common/spdCore/validation/enums';
import { GetJudgmentExtendedDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/GetJudgmentExtendedDto';

const isCancellationPending = (judgment: GetJudgmentExtendedDto) => {
  const status = judgment.cancelStatusP1 as unknown as SimP1StatusEnum;
  return (
    status === SimP1StatusEnum.ToSign || status === SimP1StatusEnum.WaitingForP1
  );
};

export const JudgmentNumberCell: React.FC<{
  judgment: GetJudgmentExtendedDto;
}> = ({ judgment }) => (
  <>
    {judgment.active && <>{judgment.number}</>}
    {!judgment.active && (
      <span className="text-decoration-line-through">{judgment.number}</span>
    )}
    {judgment.active && isCancellationPending(judgment) && (
      <Badge bg="danger" className="ms-2">
        Anulowanie
      </Badge>
    )}
    {judgment.cancellationReason && (
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            Powód anulowania: {judgment.cancellationReason}
          </Tooltip>
        }
      >
        <span className="ms-2">
          <Icon.InfoCircle />
        </span>
      </OverlayTrigger>
    )}
  </>
);
